module.exports = __webpack_public_path__ + "static/naz-8cc2ce718a8445cebd7ccab2c563e0a5.png";